import callAPI from '../../../API/callSecureAPI'
import endpoints from '../../../API/endpoints'
import { useAuth0 } from '../../../contexts/auth0-context'
import { useMutation } from 'react-query'
import { useInvalidateGetValueNarrativesQuery } from './useInvalidateGetValueNarrativesQuery'
import useInvalidateLinkingQueries from '../../../shared/queries/linking/useInvalidateLinkingQueries'

export const useAddValueMessageMutation = () => {
    const { getTokenSilently } = useAuth0()
    const { invalidateLinkingQueries } = useInvalidateLinkingQueries()

    const addValueMessage = async (valueMessage: object) => {
        try {
            const token = await getTokenSilently({ audience: 'https://atlas.aesara.com' })
            const { url, method } = endpoints.createValueMessage
            const res = await callAPI(url, method, token, valueMessage)
            invalidateLinkingQueries()

            return res
        } catch (e) {
            console.log(e)
        }
    }

    const { invalidateGetValueNarrativesQuery } = useInvalidateGetValueNarrativesQuery()

    return useMutation(addValueMessage, {
        onSuccess: async (data) => {
            await invalidateGetValueNarrativesQuery()
        },
    })
}
